import styled from "styled-components";

export const StyledMobileApp = styled("div")`
  background: linear-gradient(135deg, #c7a5fc 0%, #9884fc 50%, #6ba5fc 100%);
  padding: 64px 48px;
  position: relative;
  overflow: hidden;
`;

export const GradientBlob1 = styled("div")`
  position: absolute;
  top: -100px;
  right: -100px;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  filter: blur(60px);
`;

export const GradientBlob2 = styled("div")`
  position: absolute;
  bottom: -50px;
  left: -50px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.3) 0%, transparent 70%);
  filter: blur(50px);
`;

export const ContentContainer = styled("div")`
  position: relative;
  z-index: 1;
`;

export const SectionTitle = styled("h2")(
  ({ theme }) => `
  color: ${theme.colorBgContainer};
  font-weight: 700;
  margin-bottom: 12px;
  font-size: 32px;
`,
);

export const SectionSubtitle = styled("p")`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin: 0;
`;

export const ButtonGroup = styled("div")`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 32px;
`;

export const QRCodeCard = styled("div")(
  ({ theme }) => `
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: ${theme.borderRadiusLG * 3}px;
  padding: 32px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`,
);

export const QRCodeLabel = styled("p")(
  ({ theme }) => `
  font-size: 14px;
  color: ${theme.colorTextSecondary};
  font-weight: 500;
  margin: 16px 0 0 0;
`,
);
